import { Wrench } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import { Button } from "@react/ui-primitives/button";

import { PageView } from "../../../shared/components/PageView.tsx";
import { useMaintenanceActions } from "../hooks/useMaintenanceActions.ts";

export const MaintenanceView: FC = () => {
  const { backfillMediaPreviews } = useMaintenanceActions();

  return (
    <div className="mx-auto w-full">
      <PageView
        icon={<Wrench />}
        subtitle="Repairs run on demand"
        title="Maintenance"
      >
        <div className="flex items-center justify-between gap-4 rounded-lg border p-6">
          <div>
            <p className="font-medium">Media previews</p>
            <p className="text-sm text-muted-foreground">
              Renders the preview of every uploaded media asset created over 15
              minutes ago that holds none.
            </p>
          </div>
          <Button
            disabled={backfillMediaPreviews.isPending}
            onClick={bindArgs(backfillMediaPreviews.mutate, undefined)}
            size="sm"
            variant="outline"
          >
            {backfillMediaPreviews.isSuccess
              ? "Backfill started"
              : "Backfill previews"}
          </Button>
        </div>
      </PageView>
    </div>
  );
};
